
<main>
<div class="first-layer">
  <div class="status-buttons" *ngFor="let state of applicationsStates; let i = index" (click)="onTabClick(state.id)">
    <button [ngClass]="{
      'active': state.id == applicationStateId
    }">{{state.states}}</button>
  </div>
  <div class="search-box">
    <input class="search-input" type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()" placeholder="Search..."/>
    <img class="search-img" src="assets/search.png" />
  </div>
</div>

<table class="application-table">
  <thead>
    <tr>
      <th>No.</th>
      <th>Customer Name</th>
      <th>Mobile No</th>
      <th>State</th>
      <th>Locality</th>
      <th>Pin</th>
      <th>Financials Assistance</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let application of applications; let i = index">
      <td>{{ i + 1 }}</td>
      <td>{{ application.first_name }}</td>
      <td>{{ application.phone_number }}</td>
      <td>{{ application.state_name }}</td>
      <td>{{ application.locality }}</td>
      <td>{{ application.pin_code }}</td>
      <td>{{ application.avail_financing ? "Needed" : "Not Needed" }}</td>
      <td (click)="goToAction(application.id)">
        <img class="arrows" src="assets/UpwardArrow.png" alt="arrow" />
      </td>
    </tr>
  </tbody>
</table>
<app-pagination 
*ngIf="applications.length > 0" 
[totalItems]="totalApplications" 
[itemsPerPage]="limit" 
[currentPage]="currentPage" 
(pageChanged)="onPageChanged($event)">
</app-pagination>


</main>